import { render, staticRenderFns } from "./editable-grid.vue?vue&type=template&id=a58b5822"
import script from "./editable-grid.vue?vue&type=script&lang=js"
export * from "./editable-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports